import { render, staticRenderFns } from "./HomeSize.vue?vue&type=template&id=0175f5e9&scoped=true&"
import script from "./HomeSize.vue?vue&type=script&lang=js&"
export * from "./HomeSize.vue?vue&type=script&lang=js&"
import style0 from "./HomeSize.vue?vue&type=style&index=0&id=0175f5e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0175f5e9",
  null
  
)

export default component.exports